import { Controller } from "@hotwired/stimulus"

// Barre d'outils de l'organigramme : selecteur d'annee + bascule de vue
// (arbre / colonnes). L'etat vit dans l'URL (?annee=&vue=) et chaque
// changement recharge la page, comme les autres index de l'app. Cela garde
// l'export PDF et le partage de lien coherents avec ce qui est affiche.
export default class extends Controller {
  static values = { annee: Number, vue: String }

  setAnnee(event) {
    this._navigate({ annee: event.target.value })
  }

  prevYear() {
    this._navigate({ annee: this.anneeValue - 1 })
  }

  nextYear() {
    this._navigate({ annee: this.anneeValue + 1 })
  }

  setVue(event) {
    const vue = event.currentTarget.dataset.vue
    if (!vue || vue === this.vueValue) return
    this._navigate({ vue })
  }

  _navigate(params) {
    const url = new URL(window.location.href)
    Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value))
    window.location.href = url.toString()
  }
}
